import { useState, useCallback } from 'react';
import * as transportOrderManagementAction from "../../../redux/store-sarang/transport-order/transport-order-management.store";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../utils/configuration";
import viVN from "../../../language/vi-VN.json";

export const useSumaryDeliveryData = (showLoading) => {
    const [data, setData] = useState([]);
    const [sumaryCuisine, setSumaryCuisine] = useState();

    const GetSumaryDelivery = useCallback(async (queryData) => {
        showLoading(true);
        try {
            const res = await transportOrderManagementAction.GetSumaryDelivery(queryData);
            if (res && res.content) {
                setData(res.content);
                let sumaryLunch = 0;
                let sumaryDinner = 0;
                let sumaryQuantity = 0;
                res.content.forEach((item) => {
                    if (item.receiptTime === 2) sumaryLunch += (item.quatity || 0);
                    else if (item.receiptTime === 3) sumaryDinner += (item.quatity || 0);
                    sumaryQuantity += (item.quatity || 0);
                });
                setSumaryCuisine({
                    sumaryLunch,
                    sumaryDinner,
                    sumaryMorning: 0,
                    sumaryCuisineQuatity: sumaryQuantity,
                });
            }
        } catch (err) {
            if (err && err.errorType) {
                ShowNotification(viVN.Errors[err.errorType], NotificationMessageType.Error);
            }
        } finally {
            showLoading(false);
        }
    }, [showLoading]);

    return {
        data, setData,
        sumaryCuisine, setSumaryCuisine,
        GetSumaryDelivery
    };
};
